import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";
import { Fragment } from "react";

const ParseHtml = dynamic(() => import('../../Custom/ParseHtml'))

const ContactOfficeDepots = (props) => {
    const {
        depots
    } = props;

    const wordSpacing = {
        wordSpacing: '4px'
    }
    return (
        <ul>
            {depots.map((depot, idx) => (
                <Fragment key={idx}>
                    <Typography className="fw-bold f-size_4" color="primary" variant="h6" component="h6">{depot.name}</Typography>
                    <ParseHtml html={depot.address}/>
                    <br/>
                </Fragment>
            ))}

            <Typography className="fw-bold f-size_4" color="primary" variant="h6" component="h6">Opening Hours</Typography>
            <li>
                <Typography sx={wordSpacing}>Mon-Fri: 08:00 - 18:30</Typography>
            </li>
            <li>
                <Typography sx={wordSpacing}>Sat: 08:00 - 16:00</Typography>
            </li>
            <li>
                <Typography sx={wordSpacing}>Sun: Closed</Typography>
            </li>
            
        </ul>
    )
}

export default ContactOfficeDepots